import { Component } from '@angular/core';

/**
 * Componente de pie de página.
 *
 * Este componente representa el pie de página de la aplicación, donde se pueden mostrar enlaces,
 * información de derechos de autor y otros elementos relacionados con la navegación o la identidad de la aplicación.
 */
@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    standalone: false
})
export class FooterComponent {
  /**
   * Almacena la fecha y hora actual.
   * 
   * Esta variable contiene un objeto `Date` que representa la fecha y hora en el momento
   * en que se inicializa, es decir, cuando se crea la instancia del componente o clase.
   */
  today: Date = new Date();
}
